import { Button } from "@omni/ui/components/Button/button.component";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type ClearSelectedFacetsComponentProps = {
    onClear: () => void;
};

const ClearSelectedFacetsComponent = ({
    onClear
}: ClearSelectedFacetsComponentProps) => {
    const { t } = useGranite();

    return (
        <Button
            className="mb-2 bg-transparent text-primary"
            type="button"
            size="sm"
            outline={true}
            onClick={onClear}
        >
            {t("search.selectedRefinements.clear")}
        </Button>
    );
};

export { ClearSelectedFacetsComponent };
